<template>
  <v-col class="container__panels">
    <v-expansion-panels focusable class="expantion__panel">
      <v-expansion-panel>
        <v-expansion-panel-header class="title__list">
          {{ title1 }}
        </v-expansion-panel-header>
        <v-expansion-panel-content class="expantion__panel">
          <v-data-table
            :itemsPerPage="5"
            :items="items1"
            :headers="headers1"
            style="padding-top: 0px"
            class="dataTable__1 elevation-3 px-4"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-expansion-panels
      v-show="seeTables"
      focusable
      class="expantion__panel mt-3"
    >
      <v-expansion-panel>
        <v-expansion-panel-header class="title__list">
          {{ title2 }}
        </v-expansion-panel-header>
        <v-expansion-panel-content class="expantion__panel">
          <v-data-table
            class="dataTable__1 elevation-3 px-4"
            :itemsPerPage="5"
            style="padding-top: 0px"
            :items="items2"
            :headers="headers2"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-col>
</template>

<script>
export default {
  props: {
    seeTables: Boolean,
    title1: String,
    title2: String,
    items1: Array,
    headers1: Array,
    items2: Array,
    headers2: Array,
  },
};
</script>

<style scoped>
/* .title {
    color: #39537a;
    font-weight: lighter;
    font-size: 18px !important 
} */

.container__tables {
  display: flex !important;
  flex-direction: column !important;
}

.table__1 {
  display: flex !important;
  justify-content: center !important;
}

.card__table1 {
  width: 250px !important;
  margin-left: 14px !important;
  border: 2px solid #39537a !important;
}

.p__table1 {
  padding: 0px !important;
  margin-bottom: 0px !important;
  color: #39537a !important;
}

.table__2 {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.card_table2 {
  width: 240px !important;
  margin-left: 14px !important;
  border: 2px solid #39537a !important;
}

.p__table2 {
  padding: 0px !important;
  margin-bottom: 0px !important;
  color: #39537a !important;
  align-items: center !important;
}

.dataTable__1 {
  width: 1030px !important;
  padding: 0px !important;
  margin-top: 20px !important;
  overflow-y: scroll !important;
  max-height: 200px !important;
}

.container__table {
  display: flex !important;
  justify-content: center !important;
}

.v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
  padding: 5px 10px !important;
}
.title__list {
  color: #39537a !important;
  font-weight: lighter !important;
  font-size: 17px !important;
}
.expantion__panel {
  max-width: 1050px !important;
}
@media (min-width: 300px) and (max-width: 850px) {
  .expantion__panel {
    max-width: auto !important;
  }
}

.container__panels {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
}
</style>
